import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarHtmlComponent } from '../shared/html-snackbar/html-snackbar.component';

@Injectable({
    providedIn: 'root',
})
export class SnackbarService {
    constructor(private readonly snackBar: MatSnackBar) {}

    openSnackbar(type: 'error' | 'success' | 'info' | 'custom', message: string, duration: number | null = 9000, panelClass?: string) {
        const config = {
            duration: duration ?? Infinity,
            panelClass: panelClass ? [panelClass, `${type}-snackbar`] : [`${type}-snackbar`],
        };

        this.snackBar.openFromComponent(SnackbarHtmlComponent, {
            data: message,
            ...config,
        });
    }
}
